import { Component, OnInit, Input, Output, EventEmitter, SimpleChange } from '@angular/core';
import { TraductorService } from '../../servicios/traductor.service';
import { Subscription,fromEvent } from 'rxjs';


declare var $: any;
@Component({
  selector: 'app-barra',
  templateUrl: './barra.component.html',
  styleUrls: ['./barra.component.css']
  
})
export class BarraComponent implements OnInit {
  public suscripcion : Subscription;
  public idiomaB:string;
  public idioma:any;
  constructor(
    private _traductorService: TraductorService
  ) {
    this.idiomaB = localStorage.getItem("idioma");
    
  }

  // Envio del evento
  sendEvent(event$: number): void {
        this.idioma = event$;        
        this._traductorService.sendEvent(event$)
  }

  ngOnInit() {
    this.suscripcion = this._traductorService.getEvento().subscribe(
      result => {
        if (result) {
          if (result == 1) {
            localStorage.clear();
            location.reload();
          } else if (result == 2) {
            this.idiomaB = "2";
            localStorage.setItem("idioma",this.idiomaB);
          } else if (result == 3) {
            this.idiomaB = "3";
            localStorage.setItem("idioma",this.idiomaB);
          } else if (result == 4){
            this.idiomaB = "4";
            localStorage.setItem("idioma", this.idiomaB);
          } else if (result == 5){
            this.idiomaB = "5";
            localStorage.setItem("idioma", this.idiomaB);
          } else if (result == 6){
            this.idiomaB = "6";
            localStorage.setItem("idioma", this.idiomaB);
          } else if (result == 7){
            this.idiomaB = "7";
            localStorage.setItem("idioma", this.idiomaB);
          } else if (result == 8){
            this.idiomaB = "8";
            localStorage.setItem("idioma", this.idiomaB);
          }
        }
      },
      error => {
        console.log(error)
      }
    )
    $('#myModal').on('shown.bs.modal', function () {
      $('#myInput').trigger('focus')
    })
  }

  ngOnDestroy(): void {

    this.suscripcion.unsubscribe();
  }

  //cambio idioma barra.
  getClassEn() {
    // let home = document.getElementById("home").textContent = "Home";
    // let br1 = document.getElementById("br1").textContent = "Video";
    // let br2 = document.getElementById("br2").textContent = "Contact us";
    // let br3 = document.getElementById("br3").textContent = "language";
  }
  getClassZh() {
    //let home = document.getElementById("home").textContent = "家";
    // let br1 = document.getElementById("br1").textContent = "視頻";
    // let br2 = document.getElementById("br2").textContent = "聯繫我們";
    // let br3 = document.getElementById("br3").textContent = "語言";
  }


}

